import React from "react";
import {NavLink} from "react-router-dom";
import ContentBox from "../../../../../../../components/content-box/ContentBox";
import PageActions from "../../../../../../base/PageActions";
import Breadcrumbs from "../../../../../../../components/breadcrumbs/Breadcrumbs";
import _image_service from "../../../../../../../services/ImageService";
import '../../../../../../styles/Common.scss';
import '../../../WorldPages.scss';
import '../MagicItemsPage.scss';

interface MagicMageTechPageProps {
}

const MagicMageTechPage = (props: MagicMageTechPageProps) => {

    const page: PageActions = new PageActions({
        title: `Casarok: Mage-tech - Chase the Fox`,
        description: "Mage-tech are machines, vehicles, or circuits that have the capacity for automatic spellcasting in Casarok!",
        keywords: ["casarok", "magic", "magic compendium", "magic item", "magical", "magical item", "mage-tech", "magitech", "magic machine"],
        imgSrc: `chase/world/magic/items/mage-tech.png`,
        url: `world/magic/items/mage-tech`
    });

    return page.generateMetaContent(
        <>
            <ContentBox header="Mage-tech">
                <Breadcrumbs path={page.getUrl()}/>
                <div className="world-page-static">
                    <img className="magic-item-pic right"
                         src={_image_service.getCdnImageSrc(`chase/world/magic/items/mage-tech.png`)}
                         alt="A set of gears glwing with magic attached to a display"
                         title="A recreation of the first mage-tech device invented in Casarok"/>
                    <p>
                        Mage-tech encompasses all machines, vehicle, circuits, or other mechanical or computational
                        components that have the capability for automatic spellcasting. The spells are "taught" to the
                        machine using a process known as imprinting, and this requires the machine to have a certain
                        amount of magical metal within them to be able to hold and cast the spell. When the imprinter
                        wants to imbue a piece of mage-tech with a spell, they are required not only to enchant the
                        spell onto to but also provide a set of regimens with which it will cast the spell. Since its
                        invention, mage-tech has a wide variety of regimens. The most common regimen is automatic on a
                        fixed interval. Any number of triggers can be used such as pressure, temperature, use schedule,
                        or the presence of another object or magic. The process of imprinting is costly on one's mana
                        and usually requires a special set of tools to complete successfully.
                    </p>
                    <p>
                        Machines existed in Casarok for centuries before the invention of mage-tech. While enchantments
                        could be used on machines and helped lead the way for extremely complex clockwork and steam
                        powered machines, they were still challenging to do. For one, machines have many small parts.
                        Knowing all of them, let alone knowing how to enchant them, was a skill set which very few
                        anthros in the world possessed. Second, advanced machines had a strange resistance to such
                        enchantments. It was a complete mystery to the people of Casarok why this was the case. Research
                        into this issue continues even into
                        the <NavLink className="world-link" to="/world/history/modern-age">modern day</NavLink>.
                    </p>
                    <p>
                        The first piece of mage-tech that was invented was a simple set of gears. They had the ability
                        to cast a spell on themselves every few days that fixed issues with general wear that may occur
                        due to friction or from small amounts of damage. The magic needed to be recharged every so often
                        to prevent the imprinting from fading away. Advancements over time led to mage-tech needing
                        recharges less frequently or the parts being cheap enough to be completely replaced. Old
                        mage-tech parts which were discarded could also be recycled and imprinted upon again to make
                        new mage-tech. Green initiatives were started in several countries which championed this cause.
                    </p>
                    <p>
                        The most notable examples of mage-tech are in robots and smartphones. Starting in
                        the <NavLink className="world-link" to="/world/history/machination-age">Machination Age</NavLink>, robots
                        were capable of performing some complex tasks. Many of them were converted for use in the
                        Machinization War, which sparked a lot of outrage for robotic weapons ever since. The country
                        of Berun where the war originated is highly scrupulous regarding who they sell mage-tech and
                        robots to. On the other hand, mage-tech incorporated into smartphones provide functionality
                        useful in everyday life. The most common are specialized chips that
                        provide <NavLink className="world-link" to="/world/magic/items/bulletguard">bulletguard</NavLink> protection
                        as well as weak <NavLink className="world-link" to="/world/magic/items/ward">wards</NavLink>.
                    </p>
                </div>
            </ContentBox>
        </>
    );
}

export default MagicMageTechPage;